// extracted by mini-css-extract-plugin
module.exports = {"border":"main_border__3mMvo"};